import * as Sentry from '@sentry/vue'

/**
 * @module
 * @name Error
 */
export default {
  name: 'Error',
  methods: {
    /**
     * @function
     * @name routeBack
     * @description Push router to go to last route.
     */
    routerBack: function() {
      this.$router.go(-2)
    }
  },
  mounted() {
    localStorage.clear()

    // Send sentry custom event
    const scope = new Sentry.Scope()
    scope.setTag('section', 'Error View')
    Sentry.captureException(new Error('User ends on error view'), () => scope)
  }
}
